import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgNespressoMachine = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0a1 1 0 0 1 1 1v19h-9V6H5.66L5 8H4l-.67-2H0V1a1 1 0 0 1 1-1h18ZM9 19v1H0v-1h9ZM19 1H1v4h11v14h7V1ZM8 11v3c0 2.21-1.567 4-3.5 4-1.874 0-3.405-1.684-3.496-3.8L1 14v-3h7Zm-1 1H2v1.979l.003.178C2.073 15.772 3.198 17 4.5 17c1.299 0 2.414-1.22 2.495-2.814L7 14v-2Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgNespressoMachine;